import { Dispatch } from "react";
import { ApiConfig } from "../../Config/CommonConfig";
import { GETAPI, POSTAPI, PUTAPI } from "../../API/Api";
import {
  GET_CMS_PAGE_DETAIL_FAIL,
  GET_CMS_PAGE_DETAIL_REQUEST,
  GET_CMS_PAGE_DETAIL_SUCCESS,
  GET_CMS_PAGE_LIST_FAIL,
  GET_CMS_PAGE_LIST_REQUEST,
  GET_CMS_PAGE_LIST_SUCCESS,
  POST_CMS_PAGE_CREATE_FAIL,
  POST_CMS_PAGE_CREATE_REQUEST,
  POST_CMS_PAGE_CREATE_SUCCESS,
} from "../../Constants/CmsConstants";

const encodeSlug = (slug: string) => encodeURIComponent(slug);

export const CmsPageListAction =
  (queryString: string) => async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: GET_CMS_PAGE_LIST_REQUEST });
      const qs = queryString.startsWith("?") ? queryString : `?${queryString}`;
      const data = await GETAPI(ApiConfig.CmsPageList + qs, false);
      if (data && data.status === true) {
        dispatch({
          type: GET_CMS_PAGE_LIST_SUCCESS,
          data: data.data,
        });
      } else {
        dispatch({
          type: GET_CMS_PAGE_LIST_FAIL,
          data: data ?? null,
        });
      }
    } catch (error) {
      dispatch({
        type: GET_CMS_PAGE_LIST_FAIL,
        data: null,
      });
    }
  };

export const CmsPageDetailAction =
  (slug: string) => async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: GET_CMS_PAGE_DETAIL_REQUEST });
      const data = await GETAPI(
        `${ApiConfig.CmsPageRetrieve}${encodeSlug(slug)}/`,
        false
      );
      if (data && data.status === true) {
        dispatch({
          type: GET_CMS_PAGE_DETAIL_SUCCESS,
          data: data.data,
        });
      } else {
        dispatch({
          type: GET_CMS_PAGE_DETAIL_FAIL,
          data: data ?? null,
        });
      }
    } catch (error) {
      dispatch({
        type: GET_CMS_PAGE_DETAIL_FAIL,
        data: null,
      });
    }
  };

export const CmsPageCreateAction =
  (payload: Record<string, unknown>) => async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: POST_CMS_PAGE_CREATE_REQUEST });
      const data = await POSTAPI(ApiConfig.CmsPageCreate, payload, true);
      if (data && data.status === true) {
        dispatch({
          type: POST_CMS_PAGE_CREATE_SUCCESS,
          data: data.data,
        });
        return data;
      }
      dispatch({
        type: POST_CMS_PAGE_CREATE_FAIL,
        data: data ?? null,
      });
      return data;
    } catch (error) {
      dispatch({
        type: POST_CMS_PAGE_CREATE_FAIL,
        data: null,
      });
      return null;
    }
  };

export const CmsPageUpdateApi = (
  slug: string,
  payload: Record<string, unknown>,
  toastStatus: boolean = true
) => {
  return PUTAPI(
    `${ApiConfig.CmsPageUpdate}${encodeSlug(slug)}/`,
    payload,
    toastStatus
  );
};

export const CmsPagePublishApi = (slug: string, toastStatus: boolean = true) => {
  return POSTAPI(
    `${ApiConfig.CmsPagePublish}${encodeSlug(slug)}/`,
    {},
    toastStatus
  );
};

export const CmsPageArchiveApi = (slug: string, toastStatus: boolean = true) => {
  return POSTAPI(
    `${ApiConfig.CmsPageArchive}${encodeSlug(slug)}/`,
    {},
    toastStatus
  );
};
